import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function ImportReferenceTypeEditTemplate({ editView }) {
    const {
        contentLoading,
        form,
    } = editView;

    return (
        <ApplicationEditLayout store={editView}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicInput field={form.$('name')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

ImportReferenceTypeEditTemplate.propTypes = {
    editView: PropTypes.object
};

export default defaultTemplate(ImportReferenceTypeEditTemplate);
